import React from 'react';

import { useTranslation } from 'react-i18next';

import { ReactComponent as OpenSeaIcon } from '@pkg/assets/icons/v2/opensea.svg';
import { Button } from '@pkg/components';
import { useAppSelector } from '@pkg/hooks';

import { useEmojisStore } from '@app/store/zustand/emojis/useEmojisStore';

import { VisualizerSection } from '../VisualizerSection';
import { StepContent, Text, Title } from '../YatMintFlow.style';

import { StepContentWrapper, StepWrapper } from './MintingSteps.style';

export function Minted() {
    const { t } = useTranslation(['nft', 'dashboard']);
    const { openSeaUrl } = useAppSelector((state) => state.nft);
    const { visualizerFiles } = useEmojisStore();
    const videoSrc = visualizerFiles?.video;
    const visualizerMarkup = videoSrc ? <VisualizerSection key="video" src={videoSrc} /> : null;
    function onClickOpensea() {
        window.open(openSeaUrl || '', '_blank');
    }
    return (
        <StepContent>
            <StepWrapper>
                <StepContentWrapper key="mint-intro">
                    <Title>{t('mint_yat_complete_title')}</Title>
                    <Text>{t('mint_yat_complete_text')}</Text>
                </StepContentWrapper>
                {visualizerMarkup}
                <StepContentWrapper key="minted-ctas">
                    <Button startIcon={<OpenSeaIcon />} variant="foggy" color="secondary" onClick={onClickOpensea}>
                        {t('dashboard:view_on_opensea')}
                    </Button>
                </StepContentWrapper>
            </StepWrapper>
        </StepContent>
    );
}
